/*!
 * ymm-finder.js — product-page fit finder. Shows a live "fits / doesn't fit / universal" verdict for THIS
 * product against the active garage vehicle, and an inline Make/Model/Year + VIN picker to set/change it.
 * Recomputes on 'ymm:garage'. No network, no deps. Mount carries data-ymm-finder="<sku>".
 */
(function (w) {
  'use strict';
  function el(t, c, h) { var e = document.createElement(t); if (c) e.className = c; if (h != null) e.innerHTML = h; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }

  function YMMFinder(mount) {
    this.el = typeof mount === 'string' ? document.querySelector(mount) : mount;
    if (!this.el) return;
    this.sku = this.el.getAttribute('data-ymm-finder') || this.el.getAttribute('data-sku') || '';
    this.collection = this.el.getAttribute('data-collection') || '/collections/all';
    var self = this;
    this.build();
    w.YMM.onReady(function () { self.update(); });
    document.addEventListener('ymm:garage', function () { self.update(); });
  }

  YMMFinder.prototype.build = function () {
    this.el.classList.add('ymm-finder');
    this.verdictBox = el('div', 'ymm-verdict', '<span class="ymm-verdict__msg">Checking fit…</span>');
    this.pickerWrap = el('div', 'ymm-finder__picker');
    this.toggle = el('button', 'ymm-finder__toggle', 'Check your bike');
    this.toggle.type = 'button';
    var self = this;
    this.toggle.addEventListener('click', function () { self.pickerWrap.classList.toggle('is-open'); if (self.pickerWrap.classList.contains('is-open') && !self.widget) self.mountWidget(); });
    this.el.innerHTML = '';
    this.el.appendChild(this.verdictBox);
    this.el.appendChild(this.toggle);
    this.el.appendChild(this.pickerWrap);
  };

  // picker = garage (recent vehicles) + the Year→Make→Family→Model + VIN widget, like the source's finder
  YMMFinder.prototype.mountWidget = function () {
    var self = this;
    var recent = (w.YMMGarage && w.YMMGarage.list()) || [];
    if (recent.length) {
      var g = el('div', 'ymm-garage');
      g.innerHTML = '<span class="ymm-garage__lbl">Your garage:</span>';
      recent.forEach(function (veh) {
        var b = el('button', 'ymm-garage__chip', esc(veh.label));
        b.type = 'button';
        b.addEventListener('click', function () {
          if (w.YMMGarage) w.YMMGarage.set(veh);
          self.pickerWrap.classList.remove('is-open');
        });
        g.appendChild(b);
      });
      this.pickerWrap.appendChild(g);
    }
    var host = el('div');
    this.pickerWrap.appendChild(host);
    this.widget = new w.YMMWidget(host, { vin: true, compact: true, onApply: function (veh) {
      if (w.YMMGarage) w.YMMGarage.set(veh);
      self.pickerWrap.classList.remove('is-open');
    } });
  };

  YMMFinder.prototype.update = function () {
    if (!w.YMM || !w.YMM.engine) return;
    var veh = w.YMMGarage && w.YMMGarage.get();
    var box = this.verdictBox;
    if (!veh) {
      box.className = 'ymm-verdict is-none';
      box.innerHTML = '<span class="ymm-verdict__msg">Select your bike to check if this fits.</span>';
      this.toggle.textContent = 'Select your bike';
      return;
    }
    this.toggle.textContent = 'Change bike (' + esc(veh.label) + ')';
    var v = w.YMM.verdict(this.sku, veh);
    var cls = (w.YMM.fitClass && w.YMM.fitClass(veh)) || 'fits';
    var tag = w.YMM.fitTag(veh);
    var link = w.YMM.fitUrl(veh, w.YMM_FIT_COLLECTIONS, this.collection);
    if (v === 'fits') {
      box.className = 'ymm-verdict is-fit';
      box.innerHTML = '<span class="ymm-verdict__icon">✓</span><span class="ymm-verdict__msg">Fits your <strong>' + esc(veh.label) + '</strong></span>';
    } else if (v === 'universal') {
      box.className = 'ymm-verdict is-uni';
      box.innerHTML = '<span class="ymm-verdict__icon">✓</span><span class="ymm-verdict__msg">Universal — fits your <strong>' + esc(veh.label) + '</strong></span>';
    } else if (v === 'unknown') {
      // no fitment data for this SKU — say so plainly rather than guessing
      box.className = 'ymm-verdict is-none';
      box.innerHTML = '<span class="ymm-verdict__msg">Fitment for this product isn\'t listed yet — contact us to confirm it fits your <strong>' + esc(veh.label) + '</strong>.</span>';
    } else if (cls === 'screen-only') {
      // Joe 2026-07-18: no factory audio → a bypass/media-box has nothing to attach to. Don't say "doesn't
      // fit / see parts" (there are none); point the rider to the standalone screen (promote the Pro).
      box.className = 'ymm-verdict is-uni';
      box.innerHTML = '<span class="ymm-verdict__msg">Your <strong>' + esc(veh.label) + '</strong> has no factory radio to bypass — add wireless Apple CarPlay &amp; Android Auto with a <a class="ymm-verdict__link" href="/collections/hogplay-media-screens">HogPlay Media Screen</a> (we recommend the Screen 7 Pro).</span>';
    } else {
      box.className = 'ymm-verdict is-nofit';
      box.innerHTML = '<span class="ymm-verdict__icon">✗</span><span class="ymm-verdict__msg">Doesn\'t fit your <strong>' + esc(veh.label) + '</strong></span>' +
        ' <a class="ymm-verdict__link" href="' + esc(link) + '">See parts that fit &rarr;</a>';
    }
  };

  w.YMMFinder = YMMFinder;
  // mount EVERY finder on the page (inline buy-box block and/or a section below)
  document.addEventListener('DOMContentLoaded', function () {
    var nodes = document.querySelectorAll('[data-ymm-finder]');
    for (var i = 0; i < nodes.length; i++) new YMMFinder(nodes[i]);
  });
})(window);
